// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"ae570692","457":"1b56b56f","631":"2b94cfbe","681":"c0d25217","689":"f2463097","847":"9bcaa076"}[chunkId] + ".chunk.js";
};